import React, { useEffect, useState } from 'react'

import Page from "../../components/Page"
import CourseLaunchSection from '../../components/Course/CourseLaunchSection';
import ModuleDetail from '../modulePages/moduleDetail';
import { useDispatch, useSelector } from 'react-redux';
import { getProductCategories, getProductCategoriesDataClear, getSubProductCategoriesDataClear } from '../../redux/courses/actions';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import { setJoyRideReq } from '../../redux/assignCourse/actions';
import { SessionKeys, getStepIndex } from '../../utils/AppUtils';
import { joyRideSteps } from '../../utils/joyRideJsonScript';
import CourseCategoryListingSection from '../../components/Course/CourseCategoryListingSection';
//import { backgroundImage } from 'html2canvas/dist/types/css/property-descriptors/background-image';

const CourseCategories = () => {

  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <Loader start={isLoading} />
      <Page>
        <CourseCategoryListingSection 
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </Page>
    </>
  )
}

export default CourseCategories